import { render, staticRenderFns } from "./EducationMaterialsApp.vue?vue&type=template&id=2e2d5918&scoped=true&"
import script from "./EducationMaterialsApp.vue?vue&type=script&lang=js&"
export * from "./EducationMaterialsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2d5918",
  null
  
)

export default component.exports